/**
 * ProBadge — a small "PRO" pill shown next to features gated to the
 * Professional plan. Replaces the ambiguous lock icon so users immediately
 * understand the feature is available on the Professional tier rather than
 * being broken or permanently inaccessible.
 *
 * Rendered as a self-contained SVG so it stays crisp at any size and needs no
 * external assets.
 */
export default function ProBadge({ className = "h-4 w-auto shrink-0" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 30 16"
      role="img"
      aria-label="Professional plan feature"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="29" height="15" rx="4" fill="#f59e0b" />
      <text
        x="15"
        y="11.5"
        textAnchor="middle"
        fontFamily="ui-sans-serif, system-ui, sans-serif"
        fontSize="9"
        fontWeight="700"
        letterSpacing="0.5"
        fill="#ffffff"
      >
        PRO
      </text>
    </svg>
  );
}
